<div class="ppl-container-body">
  <div class="ppl-container">
    <div class="ppl-content-container" style="padding: 8px; max-height: calc(100vh - 140px); box-sizing: border-box;">
      <div class="line1">
        <div class="action">
          <ppl-button [label]="'Back'" icon="fa fa-chevron-left" (click)="goBack()"
            [customClass]="'primary-button semi-rounded'" [iconPosition]="'left'"></ppl-button>
        </div>
      </div>
      <div class="line2">
        {{pageTitle}}
      </div>
      <div style="width: 100%">
        <ppl-accordion [title]="'Basic Information'" [isOpen]="true">
          <div class="wiz-body">
            <div class="ppl-mt24">
              <div class="custom-row">
                @if((mode==="edit") && !this.isNew){
                <ppl-button label="Cancel" icon="fa fa-ban" [customClass]="'alt-button'" [iconPosition]="'left'"
                  (click)="onCancel()"></ppl-button>
                <ppl-button label="Save" icon="fa fa-floppy-o" [customClass]="'alt-button'" [iconPosition]="'left'"
                  (click)="onUpdate()"></ppl-button>
                }
                <!-- @if(mode==="read" && !this.isNew){
                <ppl-button label="Edit" icon="fa fa-pencil" [customClass]="'ghost-button'" [iconPosition]="'left'"
                  (click)="onEdit()"></ppl-button>
                } -->
              </div>
              @if(mode==="edit"){
              <form nz-form [formGroup]="participantProviderRates" class="ppl-p0 form-container">
                @if(isAttrAvailable('region')){
                <nz-form-item nz-col class="ppl-form-item">
                  <nz-form-label [nzSm]="6" [nzXs]="24" nzFor="region"
                    class="ppl-form-label">{{getAttributes('region').label}}
                    @if(getAttributes('region').mandatory === 'Y'){
                    <span [attr.aria-label]="'Required'">*</span>
                    }
                  </nz-form-label>
                  <nz-form-control [nzSm]="12" [nzXs]="24" class="ppl-form-control">
                    <div nz-tooltip [nzTooltipTitle]="getAttributes('region')?.tooltip || ''"
                      nzTooltipPlacement="topRight">
                      <div [ngClass]="{'error': validationErrors['region'] }">
                        <ppl-dropdown-select (selectionChange)="updateCountiesList($event)" formControlName="regionId"
                          id="regionId" class="ppl-select" [options]="regions" [optionLabel]="'regionName'"
                          [optionValue]="'payRegionId'">
                        </ppl-dropdown-select>
                      </div>
                    </div>
                    @if (validationErrors['region']) {
                    <span class="pl-1 error-message">{{validationErrors['region']}}</span>
                    }
                  </nz-form-control>
                </nz-form-item>
                }

                @if(isAttrAvailable('county')){
                <nz-form-item nz-col class="ppl-form-item">
                  <nz-form-label [nzSm]="6" [nzXs]="24" nzFor="county"
                    class="ppl-form-label">{{getAttributes('county').label}}
                    @if(getAttributes('county').mandatory === 'Y'){
                    <span [attr.aria-label]="'Required'">*</span>
                    }
                  </nz-form-label>
                  <nz-form-control [nzSm]="12" [nzXs]="24" class="ppl-form-control">
                    <div nz-tooltip [nzTooltipTitle]="getAttributes('county')?.tooltip || ''"
                      nzTooltipPlacement="topRight">
                      <div [ngClass]="{'error': validationErrors['county'] }">
                        <ppl-dropdown-select formControlName="countyId" id="countyId" class="ppl-select"
                          [options]="counties" [optionLabel]="'regionCountyName'" [optionValue]="'payRegionCountyId'">
                        </ppl-dropdown-select>
                      </div>
                    </div>
                    @if (validationErrors['county']) {
                    <span class="pl-1 error-message">{{validationErrors['county']}}</span>
                    }
                  </nz-form-control>
                </nz-form-item>
                }

                @if(isAttrAvailable('union')){
                  <nz-form-item nz-col class="ppl-form-item">
                      <nz-form-label [nzSm]="6" [nzXs]="24" nzFor="union"
                        class="ppl-form-label">{{getAttributes('union').label}}
                        @if(getAttributes('union').mandatory === 'Y'){
                        <span [attr.aria-label]="'Required'">*</span>
                        }
                      </nz-form-label>
                      <nz-form-control [nzSm]="12" [nzXs]="24" class="ppl-form-control">
                        <div nz-tooltip [nzTooltipTitle]="getAttributes('union')?.tooltip || ''"
                          nzTooltipPlacement="topRight">
                        <div [ngClass]="{'error': validationErrors['union'] }">
                          <ppl-dropdown-select formControlName="union" id="union" class="ppl-select"
                            [options]="radioBooleanOptions" [optionLabel]="'label'" [optionValue]="'value'">
                          </ppl-dropdown-select>
                        </div>
                        </div>
                        @if (validationErrors['union']) {
                        <span class="pl-1 error-message">{{validationErrors['union']}}</span>
                        }
                      </nz-form-control>
                  </nz-form-item>
                  }

                  @if(isAttrAvailable('cbatypeLkp')){
                    <nz-form-item nz-col class="ppl-form-item">
                        <nz-form-label [nzSm]="6" [nzXs]="24" nzFor="cbatypeLkp"
                          class="ppl-form-label">{{getAttributes('cbatypeLkp').label}}
                          @if(getAttributes('cbatypeLkp').mandatory === 'Y'){
                          <span [attr.aria-label]="'Required'">*</span>
                          }
                        </nz-form-label>
                        <nz-form-control [nzSm]="12" [nzXs]="24" class="ppl-form-control">
                          <div nz-tooltip [nzTooltipTitle]="getAttributes('cbatypeLkp')?.tooltip || ''"
                            nzTooltipPlacement="topRight">
                          <div [ngClass]="{'error': validationErrors['cbatypeLkp'] }">
                            <ppl-dropdown-select formControlName="cbatypeLkp" id="cbatypeLkp" class="ppl-select"
                              [options]="CBATypes" [optionLabel]="'lkpValueName'" [optionValue]="'lkpValueName'">
                            </ppl-dropdown-select>
                          </div>
                          </div>
                          @if (validationErrors['cbatypeLkp']) {
                          <span class="pl-1 error-message">{{validationErrors['cbatypeLkp']}}</span>
                          }
                        </nz-form-control>
                    </nz-form-item>
                    }

                  @if(isAttrAvailable('grandFathered')){
                    <nz-form-item nz-col class="ppl-form-item">
                        <nz-form-label [nzSm]="6" [nzXs]="24" nzFor="grandFathered"
                          class="ppl-form-label">{{getAttributes('grandFathered').label}}
                          @if(getAttributes('grandFathered').mandatory === 'Y'){
                          <span [attr.aria-label]="'Required'">*</span>
                          }
                        </nz-form-label>
                        <nz-form-control [nzSm]="12" [nzXs]="24" class="ppl-form-control">
                          <div nz-tooltip [nzTooltipTitle]="getAttributes('grandFathered')?.tooltip || ''"
                            nzTooltipPlacement="topRight">
                          <div [ngClass]="{'error': validationErrors['grandFathered'] }">
                            <ppl-dropdown-select formControlName="grandFathered" id="grandFathered" class="ppl-select"
                          [options]="radioBooleanOptions" [optionLabel]="'label'" [optionValue]="'value'">
                            </ppl-dropdown-select>
                          </div>
                          </div>
                          @if (validationErrors['grandFathered']) {
                          <span class="pl-1 error-message">{{validationErrors['grandFathered']}}</span>
                          }
                        </nz-form-control>
                    </nz-form-item>
                    }

                    @if(isAttrAvailable('consumerTypeLkp')){
                      <nz-form-item nz-col class="ppl-form-item">
                          <nz-form-label [nzSm]="6" [nzXs]="24" nzFor="consumerTypeLkp"
                            class="ppl-form-label">{{getAttributes('consumerTypeLkp').label}}
                            @if(getAttributes('consumerTypeLkp').mandatory === 'Y'){
                            <span [attr.aria-label]="'Required'">*</span>
                            }
                          </nz-form-label>
                          <nz-form-control [nzSm]="12" [nzXs]="24" class="ppl-form-control">
                            <div nz-tooltip [nzTooltipTitle]="getAttributes('consumerTypeLkp')?.tooltip || ''"
                              nzTooltipPlacement="topRight">
                            <div [ngClass]="{'error': validationErrors['consumerTypeLkp'] }">
                              <ppl-dropdown-select formControlName="consumerTypeLkp" id="consumerTypeLkp" class="ppl-select"
                                [options]="consumerTypes" [optionLabel]="'lkpValueName'" [optionValue]="'lkpValueName'">
                              </ppl-dropdown-select>
                            </div>
                            </div>
                            @if (validationErrors['consumerTypeLkp']) {
                            <span class="pl-1 error-message">{{validationErrors['consumerTypeLkp']}}</span>
                            }
                          </nz-form-control>
                      </nz-form-item>
                      }

                @if(isAttrAvailable('code')){
                <nz-form-item nz-col class="ppl-form-item nz-padding-left">
                  <nz-form-label [nzSm]="6" [nzXs]="24" nzFor="code"
                    class="ppl-form-label">{{getAttributes('code').label}}
                    @if(getAttributes('code').mandatory === 'Y'){
                    <span [attr.aria-label]="'Required'">*</span>
                    }
                  </nz-form-label>
                  <nz-form-control [nzSm]="12" [nzXs]="24" class="ppl-form-control">
                    <div nz-tooltip [nzTooltipTitle]="getAttributes('code')?.tooltip || ''"
                      nzTooltipPlacement="topRight">
                      <div [ngClass]="{'error': validationErrors['code'] }">
                        <ppl-dropdown-select formControlName="serviceCodeDetailId" id="serviceCodeDetailId"
                          class="ppl-select" [options]="serviceCodes" [optionLabel]="'code'"
                          [optionValue]="'serviceCodeDetailId'">
                        </ppl-dropdown-select>
                      </div>
                    </div>
                    @if (validationErrors['code']) {
                    <span class="pl-1 error-message">{{validationErrors['code']}}</span>
                    }
                  </nz-form-control>
                </nz-form-item>
                }

                @if(isAttrAvailable('modifierCode1')){
                <nz-form-item nz-col class="ppl-form-item nz-padding-left">
                  <nz-form-label [nzSm]="6" [nzXs]="24" nzFor="modifierCode1"
                    class="ppl-form-label">{{getAttributes('modifierCode1').label}}
                    @if(getAttributes('modifierCode1').mandatory === 'Y'){
                    <span [attr.aria-label]="'Required'">*</span>
                    }
                  </nz-form-label>
                  <nz-form-control [nzSm]="12" [nzXs]="24" class="ppl-form-control">
                    <div nz-tooltip [nzTooltipTitle]="getAttributes('modifierCode1')?.tooltip || ''"
                      nzTooltipPlacement="topRight">
                      <div [ngClass]="{'error': validationErrors['modifierCode1'] }">
                        <ppl-dropdown-select formControlName="modifierDetailId" id="modifierDetailId" class="ppl-select"
                          [options]="modifiersList" [optionLabel]="'code'" [optionValue]="'modifierDetailId'">
                        </ppl-dropdown-select>
                      </div>
                    </div>
                    @if (validationErrors['modifierCode1']) {
                    <span class="pl-1 error-message">{{validationErrors['modifierCode1']}}</span>
                    }
                  </nz-form-control>
                </nz-form-item>
                }

                @if(isAttrAvailable('fromdate')){
                <nz-form-item nz-col class="ppl-form-item nz-padding-left">
                  <nz-form-label [nzSm]="6" [nzXs]="24" zFor="fromdate"
                    class="ppl-form-label">{{getAttributes('fromdate').label}}
                    @if(getAttributes('fromdate').mandatory === 'Y'){
                    <span [attr.aria-label]="'Required'">*</span>
                    }
                  </nz-form-label>
                  <nz-form-control [nzSm]="12" [nzXs]="24" class="ppl-form-control">
                    <div nz-tooltip [nzTooltipTitle]="getAttributes('fromdate')?.tooltip || ''"
                      nzTooltipPlacement="topRight">
                      <nz-date-picker formControlName="fromDate" id="fromdate" [nzFormat]="'MM/dd/yyyy'"
                        [nzPlaceHolder]="getAttributes('fromdate').placeholder" [nzDisabledDate]="disabledStartDate"
                        [ngClass]="{'error': validationErrors['dob'] }"></nz-date-picker>
                    </div>
                    @if (validationErrors['fromdate']) {
                    <span class="pl-1 error-message">{{validationErrors['fromdate']}}</span>
                    }
                  </nz-form-control>
                </nz-form-item>
                }
                @if(isAttrAvailable('todate')){
                <nz-form-item nz-col class="ppl-form-item nz-padding-left">
                  <nz-form-label [nzSm]="6" [nzXs]="24" nzFor="todate"
                    class="ppl-form-label">{{getAttributes('todate').label}}
                    @if(getAttributes('todate').mandatory === 'Y'){
                    <span [attr.aria-label]="'Required'">*</span>
                    }
                  </nz-form-label>
                  <nz-form-control [nzSm]="12" [nzXs]="24" class="ppl-form-control">
                    <div nz-tooltip [nzTooltipTitle]="getAttributes('todate')?.tooltip || ''"
                      nzTooltipPlacement="topRight">
                      <nz-date-picker formControlName="toDate" id="todate" [nzFormat]="'MM/dd/yyyy'"
                        [nzPlaceHolder]="getAttributes('todate').placeholder" [nzDisabledDate]="disabledEndDate"
                        [ngClass]="{'error': validationErrors['dob'] }"></nz-date-picker>
                    </div>
                    @if (validationErrors['todate']) {
                    <span class="pl-1 error-message">{{validationErrors['todate']}}</span>
                    }
                  </nz-form-control>
                </nz-form-item>
                }
                @if(isAttrAvailable('rate')){
                <nz-form-item nz-col class="ppl-form-item nz-padding-left">
                  <nz-form-label [nzSm]="6" [nzXs]="24" nzFor="rate"
                    class="ppl-form-label">{{getAttributes('rate').label}}
                    @if(getAttributes('rate').mandatory === 'Y'){
                    <span [attr.aria-label]="'Required'">*</span>
                    }
                  </nz-form-label>
                  <nz-form-control [nzSm]="12" [nzXs]="24" class="ppl-form-control">
                    <div nz-tooltip [nzTooltipTitle]="getAttributes('rate')?.tooltip || ''"
                      nzTooltipPlacement="topRight">
                      <input nz-input formControlName="rate" id="rate"
                        placeholder="{{getAttributes('rate').placeholder}}"
                        [ngClass]="{'error': validationErrors['rate'] }" />
                    </div>
                    @if (validationErrors['rate']) {
                    <span class="pl-1 error-message">{{validationErrors['rate']}}</span>
                    }
                  </nz-form-control>
                </nz-form-item>
                }
              </form>

              @if(isNew){
              <div class="custom-row">
                <ppl-button [label]="'Cancel'" [icon]="'fa fa-close'" style="margin-right:4px; font-size:0.857rem;"
                  [customClass]="'ghost-button'" [iconPosition]="'right'" (click)="goBack()"></ppl-button>
                <ppl-button label="Submit" icon="fa fa-check-circle" [customClass]="'primary-button'"
                  [iconPosition]="'right'" (click)="onAdd()"></ppl-button>
              </div>
              }
              }
              @else if (mode==="read") {
              <div nz-row>
                @if(isAttrAvailable('region')){
                <div nz-col nzSpan="12">
                  <div nz-row>
                    <div nz-col nzSpan="8" ngClass="font-weight-600 pt-2 pb-2">
                      {{ getAttributes("region").label }}
                    </div>
                    <div nz-col nzSpan="16" ngClass="pt-2 pb-2">{{ savedData?.regionName }}</div>
                  </div>
                </div>
                }
                @if(isAttrAvailable('county')){
                <div nz-col nzSpan="12">
                  <div nz-row>
                    <div nz-col nzSpan="8" ngClass="font-weight-600 pt-2 pb-2">
                      {{ getAttributes("county").label }}
                    </div>
                    <div nz-col nzSpan="16" ngClass="pt-2 pb-2">{{ savedData?.countyName }}</div>
                  </div>
                </div>
                }

                @if(isAttrAvailable('union')){
                  <div nz-col nzSpan="12">
                    <div nz-row>
                      <div nz-col nzSpan="8" ngClass="font-weight-600 pt-2 pb-2">
                        {{ getAttributes("union").label }}
                      </div>
                      <div nz-col nzSpan="16" ngClass="pt-2 pb-2">{{ savedData?.union | booleanYesNo }}</div>
                    </div>
                  </div>
                  }

                    @if(isAttrAvailable('cbatypeLkp')){
                    <div nz-col nzSpan="12">
                      <div nz-row>
                        <div nz-col nzSpan="8" ngClass="font-weight-600 pt-2 pb-2">
                          {{ getAttributes("cbatypeLkp").label }}
                        </div>
                        <div nz-col nzSpan="16" ngClass="pt-2 pb-2">{{ savedData?.cbatypeLkp }}</div>
                      </div>
                    </div>
                    }

                @if(isAttrAvailable('grandFathered')){
                  <div nz-col nzSpan="12">
                    <div nz-row>
                      <div nz-col nzSpan="8" ngClass="font-weight-600 pt-2 pb-2">
                        {{ getAttributes("grandFathered").label }}
                      </div>
                      <div nz-col nzSpan="16" ngClass="pt-2 pb-2">{{ savedData?.grandFathered | booleanYesNo }}</div>
                    </div>
                  </div>
                  }

                  
                @if(isAttrAvailable('consumerTypeLkp')){
                  <div nz-col nzSpan="12">
                    <div nz-row>
                      <div nz-col nzSpan="8" ngClass="font-weight-600 pt-2 pb-2">
                        {{ getAttributes("consumerTypeLkp").label }}
                      </div>
                      <div nz-col nzSpan="16" ngClass="pt-2 pb-2">{{ savedData?.consumerTypeLkp }}</div>
                    </div>
                  </div>
                  }

                @if(isAttrAvailable('code')){
                <div nz-col nzSpan="12">
                  <div nz-row>
                    <div nz-col nzSpan="8" ngClass="font-weight-600 pt-2 pb-2">
                      {{ getAttributes("code").label }}
                    </div>
                    <div nz-col nzSpan="16" ngClass="pt-2 pb-2">{{ savedData?.serviceCode }}</div>
                  </div>
                </div>
                }


                @if(isAttrAvailable('modifierCode1')){
                <div nz-col nzSpan="12">
                  <div nz-row>
                    <div nz-col nzSpan="8" ngClass="font-weight-600 pt-2 pb-2">
                      {{ getAttributes("modifierCode1").label }}
                    </div>
                    <div nz-col nzSpan="16" ngClass="pt-2 pb-2">{{ savedData?.modifierCode }}</div>
                  </div>
                </div>
                }

                @if(isAttrAvailable('fromdate')){
                <div nz-col nzSpan="12">
                  <div nz-row>
                    <div nz-col nzSpan="8" ngClass="font-weight-600 pt-2 pb-2">
                      {{ getAttributes("fromdate").label }}
                    </div>
                    <div nz-col nzSpan="16" ngClass="pt-2 pb-2">{{ savedData?.fromDate }}</div>
                  </div>
                </div>
                }
                @if(isAttrAvailable('todate')){
                <div nz-col nzSpan="12">
                  <div nz-row>
                    <div nz-col nzSpan="8" ngClass="font-weight-600 pt-2 pb-2">
                      {{ getAttributes("todate").label }}
                    </div>
                    <div nz-col nzSpan="16" ngClass="pt-2 pb-2">{{ savedData?.toDate }}</div>
                  </div>
                </div>
                }
                @if(isAttrAvailable('rate')){
                <div nz-col nzSpan="12">
                  <div nz-row>
                    <div nz-col nzSpan="8" ngClass="font-weight-600 pt-2 pb-2">
                      {{ getAttributes("rate").label }}
                    </div>
                    <div nz-col nzSpan="16" ngClass="pt-2 pb-2">{{ savedData?.rate }}</div>
                  </div>
                </div>
                }
              </div>
              }
            </div>
          </div>
        </ppl-accordion>
      </div>
    </div>
  </div>
</div>